import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  GoalChart = 'GoalChart',
}

export const queryKeys = {
  goalChartAll: () => [QueryFeature.FinancialPlan, QueryKey.GoalChart],

  goalChart: (clientId: string, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.GoalChart,
    clientId,
    fpId,
  ],
};
